import React from 'react';
import { Grid, Box } from '@mui/material';
import SummaryStats from './../components/dashboard/SummaryStats';
import ReportChart from '../components/dashboard/AppointmentChart';
import ProjectOverviewCard from '../components/dashboard/TaskOverviewCard';
import TransactionsCard from './../components/dashboard/TransactionsCard';
import TotalIncomePieChart from '../components/dashboard/AppointmentStatus';
import LineChart from '../components/dashboard/LineChart';
import PaymentPendingList from '../components/dashboard/PaymentPendingList';
import { useSelector } from 'react-redux';
import { isSanginiRestrictedUser } from 'src/utils/sanginiUtils';
import NotAccessible from 'src/components/App/NotAccessible';

export default function DashboardPage() {
  const user = useSelector((state) => state.auth?.user);
  if (isSanginiRestrictedUser(user)) {
    return <NotAccessible />;
  }

  return (
    <Box p={3}>
      <Grid container spacing={3}>
        <Grid item xs={12}><SummaryStats /></Grid>
        <Grid item xs={12} md={8}><ReportChart /></Grid>
        <Grid item xs={12} md={4}><ProjectOverviewCard /></Grid>
        <Grid item xs={12} md={6}><TransactionsCard /></Grid>
        <Grid item xs={12} md={6}><PaymentPendingList /></Grid>
        <Grid item xs={12} md={8}><LineChart /></Grid>
        <Grid item xs={12} md={4}><TotalIncomePieChart /></Grid>
      </Grid>
    </Box>
  );
}